import { API_TYPE } from '@umu/umu-fetch';
const PHP_BASE = '/uapi/v1/payment';

export default {
    /**
     * 获取订阅配置
     * http://api.umucdn.cn/project/216/interface/api/7522
     */
    GET_SUBSCRIPTION_CONFIG: {
        url: `${PHP_BASE}/get-subscription-config`,
        type: API_TYPE.GET,
    },
    /**
     * 获取订阅配置
     * http://api.umucdn.cn/project/216/interface/api/7522
     */
    GET_ACCOUNT_PLAN: {
        url: `/uapi/v1/user/account-plan`,
        type: API_TYPE.GET,
    },
    /**
     * 获取版本商品列表（复用原有接口）
     * http://api.umucdn.cn/project/216/interface/api/7574
     */
    GET_ACCOUNT_PLAN_PACKAGE_LIST: {
        url: `/uapi/v1/commodity/account-plan-package-list`,
        type: API_TYPE.GET,
    },
    /**
     * 计算订阅价格
     * http://api.umucdn.cn/project/216/interface/api/7514
     */
    GET_SUBSCRIPTION_AMOUNT: {
        url: `${PHP_BASE}/get-subscription-amount`,
        type: API_TYPE.GET,
    },
    /**
     * 创建订单（复用原有接口）
     * http://api.umucdn.cn/project/216/interface/api/7576
     */
    CREATE_ORDER: {
        url: `${PHP_BASE}/create-order`,
        type: API_TYPE.POST,
    },
    /**
     * 订单支付（复用原有接口）
     * http://api.umucdn.cn/project/216/interface/api/7564
     */
    CREATE_PAY: {
        url: `${PHP_BASE}/create-pay`,
        type: API_TYPE.POST,
    },
    /**
     * 查询订单状态（复用原有接口）
     * http://api.umucdn.cn/project/216/interface/api/7578
     */
    QUERY_ORDER: {
        url: `${PHP_BASE}/query-order`,
        type: API_TYPE.GET,
    },
    /**
     * 创建/更新订阅
     * http://api.umucdn.cn/project/216/interface/api/7484
     */
    SAVE_SUBSCRIPTION: {
        url: `${PHP_BASE}/save-subscription`,
        type: API_TYPE.POST,
    },
    /**
     * 取消订阅
     * http://api.umucdn.cn/project/216/interface/api/7508
     */
    CANCEL_SUBSCRIPTION: {
        url: `${PHP_BASE}/cancel-subscription`,
        type: API_TYPE.POST,
    },
    /**
     * 获取订阅详情
     * http://api.umucdn.cn/project/216/interface/api/7510
     */
    GET_SUBSCRIPTION: {
        url: `${PHP_BASE}/get-subscription`,
        type: API_TYPE.GET,
    },
    /**
     * 获取订阅客户详情
     * http://api.umucdn.cn/project/216/interface/api/7560
     */
    GET_SUBSCRIPTION_CUSTOMER: {
        url: `${PHP_BASE}/get-subscription-customer`,
        type: API_TYPE.GET,
    },
};
